import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';

import { ApiContext } from 'utils/networking/Api.context';

export default function HbxUploadTemplates() {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isModalOpen: false,
    isLoading: false,
    suscription: null /* null | active | requested */,
    adviceDeleteFile: false,
    langDelete: null,
    listTemplates: {},
  });

  const refreshListTemplates = async () => {
    try {
      const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });
      const listEnabled = await API.invoiceGetListTemplate(hotelData.id, hotelData.chainId);
      updateState({ listTemplates: listEnabled });
    } catch (err) {
      console.warn('Error refreshing templates list:', err);
    }
  };

  const actions = {
    downloadFile: async lang => {
      try {
        const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });
        const file = await API.invoiceGetDocumentTemplate(hotelData.id, hotelData.chainId, lang);
        if (!!file.data) {
          const array = new Uint8Array(file.data);
          const blob = new Blob([array], {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          });

          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${lang}_invoice_template.docx`;
          a.click();

          URL.revokeObjectURL(url);
          updateState({ isLoading: false });
          notification.success({
            message: translate('hbxProducts.invoiceAutomationFiles.fileFound'),
          });
        } else {
          updateState({ isLoading: false });
          notification.error({
            message: translate('hbxProducts.invoiceAutomationFiles.fileNotFound'),
          });
        }
      } catch (err) {
        updateState({ isLoading: false });
        notification.error({
          message: translate('hbxProducts.invoiceAutomationFiles.errorMessageDownload'),
        });
      }
    },

    deleteFile: async () => {
      try {
        updateState({ isLoading: true });
        const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });
        const response = await API.invoiceDeleteDocumentTemplate(
          hotelData.id,
          hotelData.chainId,
          state.langDelete
        );
        if (response?.metadata?.httpStatusCode === 204) {
          await refreshListTemplates();
          updateState({ isLoading: false });
          notification.success({
            message: translate('hbxProducts.invoiceAutomationFiles.fileDeleted'),
          });
        } else {
          updateState({ isLoading: false });
          notification.error({
            message: translate('hbxProducts.invoiceAutomationFiles.fileNotDeleted'),
          });
        }
      } catch (err) {
        updateState({ isLoading: false });
        notification.error({
          message: translate('hbxProducts.invoiceAutomationFiles.errorMessageDelete'),
        });
      }
    },

    UploadDocument: async (file, lang) => {
      try {
        updateState({ isLoading: true });
        const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });
        if (file.name.toLowerCase().includes('.docx')) {
          const response = await API.invoiceUploadDocumentTemplate(
            hotelData.id,
            hotelData.chainId,
            lang,
            file
          );
          if (response?.httpStatusCode === 200) {
            await refreshListTemplates();
            updateState({ isLoading: false });
            notification.success({
              message: translate('hbxProducts.invoiceAutomationFiles.fileUploaded'),
            });
          } else {
            updateState({ isLoading: false });
            notification.error({
              message: translate('hbxProducts.invoiceAutomationFiles.fileNotUploaded'),
            });
          }
        } else {
          updateState({ isLoading: false });
          notification.error({
            message: translate('hbxProducts.invoiceAutomationFiles.errorFileExtension'),
          });
        }
      } catch (err) {
        updateState({ isLoading: false });
        notification.error({
          message: translate('hbxProducts.invoiceAutomationFiles.errorMessageUpload'),
        });
      }
    },

    openInfoModal: () => {
      updateState({ isModalOpen: true });
    },

    closeInfoModal: () => {
      updateState({ isModalOpen: false });
    },

    setAdviceDeleteFile: show => {
      updateState({ adviceDeleteFile: show });
    },

    setLanguageDelete: lang => {
      updateState({ langDelete: lang });
    },

    getHbxSuscriptionStatus: async () => {
      await API.getHbxSuscriptionStatus({
        hotelId: getSelectedHotel()?.key,
        nameProduct: 'hbx_invoicing',
      }).then(res => {
        updateState({ suscription: res });
      });

      await refreshListTemplates();
    },
  };

  function updateState(obj) {
    setState(prev => ({ ...prev, ...obj }));
  }

  useEffect(() => {
    updateState({ isLoading: true });
    actions.getHbxSuscriptionStatus();
    updateState({ isLoading: false });
  }, [appState.selectedHotel]);

  return { state, actions };
}
